import {
  SINGLE_RESULT_CHAR_THRESHOLD,
  NATURAL_LANGUAGE_WORD_THRESHOLD,
  SEARCH_CHIP_CONFIG
} from "./constants";
import { ENTITY_BY_FILTER_NAME } from "../../constants/entityTypes";
import { FilterVisibility } from "../Filters/constants";

const getIconForType = typeKey =>
  ENTITY_BY_FILTER_NAME[typeKey]?.iconName ??
  SEARCH_CHIP_CONFIG[typeKey]?.iconName;

// Dynamic search icon helper
// - let's us swap search icon with relevant result icon
// - returns string prefix of an svg from assets/v2-icons
export const getSearchIcon = (input, autocompleteResults) => {
  if (!input) return "search";

  // If input exactly matches a suggestion's name/title, use that result's icon
  const normalizedInput = input.trim().toLowerCase();
  const exactMatch = autocompleteResults.find(
    item => (item.name || item.title || "").toLowerCase() === normalizedInput
  );
  if (exactMatch) {
    const typeKey = (exactMatch.type || "").toLowerCase();
    return getIconForType(typeKey) || "search";
  }

  // If we've typed at least three letters and only get one result, use that result's icon
  if (
    input.length >= SINGLE_RESULT_CHAR_THRESHOLD &&
    autocompleteResults.length === 1
  ) {
    const item = autocompleteResults[0];
    const typeKey = (item.type || "").toLowerCase();
    return getIconForType(typeKey) || "search";
  }

  // Word count determines text_search vs natural_language
  const wordCount = input.trim().split(/\s+/).length;
  if (
    wordCount < NATURAL_LANGUAGE_WORD_THRESHOLD &&
    autocompleteResults.length === 0
  ) {
    return "text_search";
  }
  if (wordCount >= NATURAL_LANGUAGE_WORD_THRESHOLD) {
    return "natural_language";
  }
  return "search";
};

const HIDDEN_FILTER_TYPES = [
  FilterVisibility.HIDDEN,
  FilterVisibility.SYSTEM_HIDDEN,
  FilterVisibility.HIDDEN_QUICK_FILTER
];

// Filter out genres/tags that have a hidden visibility flag
export const filterByVisibility = (filterItems, showAllFiltersByDefault) =>
  filterItems.filter(
    f =>
      !HIDDEN_FILTER_TYPES.includes(f.visibility) ||
      (f.visibility === FilterVisibility.ADVANCED && !showAllFiltersByDefault)
  );
